import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useCourseBundles(data = {}) {
  const { enabled = true, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getCourseBundles() {
    return privateFetch.get(`/v1/admin/courses/bundles`, configs).then((res) => res.data);
  }

  return useQuery(['course-bundles', { data }], getCourseBundles, {
    enabled,
    keepPreviousData: true,
  });
}

export default useCourseBundles;
